import { render } from "./EditionForm.vue?vue&type=template&id=6f9018ec&scoped=true"
import script from "./EditionForm.vue?vue&type=script&lang=js"
export * from "./EditionForm.vue?vue&type=script&lang=js"

import "./EditionForm.vue?vue&type=style&index=0&id=6f9018ec&lang=scss&scoped=true"

import exportComponent from "/builds/arkindex/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f9018ec"]])

export default __exports__